import Vue from 'vue'

const state = Vue.observable({
  permissions: []
})

function toArray (value) {
  if (!value) {
    return []
  }
  return Array.isArray(value) ? value.filter(Boolean) : [value]
}

export function setPermissions (permissions) {
  state.permissions = Array.isArray(permissions) ? permissions.filter(Boolean) : []
}

export function clearPermissions () {
  state.permissions = []
}

export function hasPermission (required) {
  const currentPermissions = state.permissions || []
  const requiredPermissions = toArray(required)

  if (requiredPermissions.length === 0) {
    return true
  }

  return requiredPermissions.some(item => currentPermissions.includes(item))
}

export default state
